import { render, staticRenderFns } from "./RealStaEdit.vue?vue&type=template&id=2d47b97a&scoped=true"
import script from "./RealStaEdit.vue?vue&type=script&lang=js"
export * from "./RealStaEdit.vue?vue&type=script&lang=js"
import style0 from "./RealStaEdit.vue?vue&type=style&index=0&id=2d47b97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47b97a",
  null
  
)

export default component.exports